import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App'

// Get the div with id 'root' that is native to react. 
ReactDOM.render(<App />, document.getElementById('root'));